import DataTreatment from './DataTreatment';

export default DataTreatment;
